import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './InquiryForm.css';
import countryCodesData from './countryCodes.json';

function InquiryForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    countryCode: '',
    phone: '',
    // priceRange: '',
    category: '',
    metal: '',
    carat: '',
    stone: '',
    message: '',
  });

  const getBackendUrl = () => {
    return window.location.hostname === 'localhost'
      ? process.env.REACT_APP_BACKEND_URL_LOCAL
      : process.env.REACT_APP_BACKEND_URL_PRODUCTION;
  };

  const [countryCodes] = useState(() =>
    countryCodesData.sort((a, b) => a.name.localeCompare(b.name))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validations
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name) {
      Swal.fire('Error', 'Please enter the name', 'error');
      return;
    }

    else if (!formData.email) {
      Swal.fire('Error', 'Please enter the email', 'error');
      return;
    }

    else if (!emailRegex.test(formData.email)) {
      Swal.fire('Error', 'Please enter a valid email address.', 'error');
      return;
    }

    else if (!formData.phone) {
      Swal.fire('Error', 'Please enter the phone number', 'error');
      return;
    }

    else if (!phoneRegex.test(formData.phone)) {
      Swal.fire('Error', 'Please enter a valid 10-digit phone number.', 'error');
      return;
    }

    try {
      const response = await fetch(`${getBackendUrl()}/api/inquiry/submit-inquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          adminEmail: 'jeetshah2703@gmail.com', // Admin email being passed here
        }),
      });
      

      const result = await response.json();
      if (response.ok) {
        Swal.fire('Success', 'Inquiry submitted successfully!', 'success');
        setFormData({
          name: '',
          email: '',
          countryCode: '',
          phone: '',
          // priceRange: '',
          category: '',
          metal: '',
          carat: '',
          stone: '',
          message: '',
        });
      } else {
        Swal.fire('Error', result.message || 'Something went wrong.', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Failed to submit inquiry.', 'error');
    }
  };


  return (
    <div className="inquiry-section" id="contact">
      <h2 className="inquiry-heading">Make an Inquiry</h2>
      <div className="inquiry-form">
        <div className="form-left">
          <h3>Custom Inquiry Form</h3>
          <p>
            Fill out the inquiry form to get a free quote to create the custom jewellry you’ve been dreaming of. We’ll
            respond to you within 48 hours.
          </p>
          <p>
            <strong>Monday to Saturday from</strong> <br />
            9:00 — 20:00
          </p>
          <p>
            <strong>Call to ask any question</strong> <br />
            (+81) 55-2880691
          </p>
          <div className="map-container">
  <iframe
    src="https://www.google.com/maps?q=35.628686,138.578752&z=15&output=embed"
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Google Map with Red Marker"
    className="embedded-map"
    onClick={() => window.open('https://www.google.com/maps?q=35.628686,138.578752', '_blank')}
  ></iframe>
</div>

        </div>
        <div className="form-right">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div>
                <label>Name<span className="mandatory">*</span></label>
                <input
                  type="text"
                  placeholder="Name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div>
                <label>Email<span className="mandatory">*</span></label>
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>
            </div>
            <div className="form-row">
            
              <div>
                <label>Phone Number<span className="mandatory">*</span></label>
                <div className="phone-group">
                  <select
                    value={formData.countryCode}
                    onChange={(e) => setFormData({ ...formData, countryCode: e.target.value })}
                    className="country-code"
                    required
                  >
                    <option value="">Select Country Code</option>
                    {countryCodes.map((country, index) => (
                      <option key={index} value={country.code}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    required
                  />
                </div>
              </div>
          
              {/* <div>
                <label>Price Range</label>
                <select
                  value={formData.priceRange}
                  onChange={(e) => setFormData({ ...formData, priceRange: e.target.value })}
                >
                  <option value="">Price Range</option>
                  <option value="5000">5000 yen</option>
                  <option value="10000">10000 yen</option>
                  <option value="20000">20000 yen</option>
                  <option value="50000">50000 yen</option>
                </select>
              </div> */}
            </div>
            <div className="form-row">
              <div>
                <label>Category</label>
                <select
                  value={formData.category}
                  onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                >
                  <option value="">Category</option>
                  <option value="ring">Rings</option>
                  <option value="earring">Earring</option>
                  <option value="necklace">Necklace</option>
                  <option value="bracelet">Bracelet</option>
                  <option value="pendant">Pendants</option>
                  <option value="diamond">Diamond</option>
                  <option value="gemstone">Gem Stone</option>
                </select>
              </div>
              <div>
                <label>Metal</label>
                <select
                  value={formData.metal}
                  onChange={(e) => setFormData({ ...formData, metal: e.target.value })}
                >
                  <option value="">Metal</option>
                  <option value="gold">Gold</option>
                  <option value="silver">Silver</option>
                  <option value="platinum">Platinum</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div>
                <label>Metal Carat</label>
                <select
                  value={formData.carat}
                  onChange={(e) => setFormData({ ...formData, carat: e.target.value })}
                >
                  <option value="">Metal Carat</option>
                  <option value="18k">18k</option>
                  <option value="22k">22k</option>
                  <option value="24k">24k</option>
                </select>
              </div>
              <div>
                <label>Stone</label>
                <select
                  value={formData.stone}
                  onChange={(e) => setFormData({ ...formData, stone: e.target.value })}
                >
                  <option value="">Stone</option>
                  <option value="diamond">Diamond</option>
                  <option value="ruby">Ruby</option>
                  <option value="sapphire">Sapphire</option>
                </select>
              </div>
            </div>
            <div className='message-textarea'>
              <label>Message</label>
              <textarea
                placeholder="Message"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              ></textarea>
            </div>
            <center><button type="submit" className='submit-btn'>Submit</button></center>
          </form>
        </div>


      </div>
    </div>
  );
}

export default InquiryForm;
